import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class ReportApiService extends ApiService {
  static async generatePdfReport(query: object): Promise<IServiceResponse<object>> {
    return this.axios.post('reports/generate', query)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getWeeklyMatchReport(params: { week?: string }): Promise<IServiceResponse<object>> {
    return this.axios.get('reports/weekly-matches', {
      params
    }).then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getTreatmentReport(params: object): Promise<IServiceResponse<object>> {
    return this.axios.get('reports/treatment-overview', {
      params
    }).then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
